import * as React from "react"
import { useFiltersContext } from "components/Shared/GlobalFilter/context/filtersContext"
import useFetchFilters from "components/Shared/GlobalFilter/hooks"
import {
	VENDORS_FILTER,
	VENDORS_FILTER_ENDPOINT,
} from "components/Shared/GlobalFilter/constants"
import useIsWalmartUser from "components/Shared/Hooks/useIsWalmartUser/useIsWalmartUser"
import { Tuple } from "components/Shared/Interfaces"

const useSetVendorFilters = () => {
	const isWalmartUser = useIsWalmartUser()
	const { filters, setFilters } = useFiltersContext()
	const totalVendorsSelected = filters.vendors.length
	const hasVendorSelected = totalVendorsSelected > 0
	const { data = [], refetch, isFetching } = useFetchFilters<Tuple>(
		VENDORS_FILTER_ENDPOINT,
		VENDORS_FILTER,
		undefined,
		true
	)

	React.useEffect(() => {
		refetch()
	}, [])

	React.useEffect(() => {
		if (isWalmartUser) {
			return
		}

		if (hasVendorSelected) {
			return
		}

		setFilters({
			...filters,
			vendors: data,
		})
	}, [isFetching, totalVendorsSelected])
}

export default useSetVendorFilters
